import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class LimitLicense extends ApiBase {
  constructor(store) {
    const path = `${ACTIVE_BASE_REST}/security/licenseLimit`
    super(store, path)
  }
}
